"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../constants");
function customers(state = null, action) {
    switch (action.type) {
        case constants_1.ACTIONS.Customers.SET_CHECKED_CUSTOMERS:
            return Object.assign({}, state, {
                checkedCustomers: action.payload
            });
        default:
            return state;
    }
}
exports.default = customers;


//////////////////
// WEBPACK FOOTER
// ./client/src/app/business/customers/CustomersReducer.ts
// module id = 785
// module chunks = 0 1 2